import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    bigAvatar: {
        height: theme.spacing(8),
        width: theme.spacing(8),
        marginRight: theme.spacing(1),
    },
    title: {
        color: "#140524",
        fontWeight: 700,
        fontSize: theme.spacing(3),
    },
    subTitle: {
        color: "rgba(0, 0, 0, 0.5)",
        fontWeight: 500,
        fontSize: theme.spacing(1.8),
    },
    video: {
        position: "relative",
        "& video": {
            objectFit: "cover",
        },
    },
    search: {
        [`& fieldset`]: {
            borderRadius: theme.spacing(4),
        },
    },
    toolbar: {
        minHeight: "unset",
    },
    content: {
        flexGrow: 1,
        padding: 1,
        marginTop: 64,
    },
    main: {
        padding: theme.spacing(2),
        flexGrow: 1,
        height: "calc(100vh - 88px)",
    },
    gettingLabel: {
        fontWeight: 700,
        fontSize: theme.spacing(2),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    gettingdesc: {
        fontWeight: 500,
        fontSize: theme.spacing(1.7),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        color: "rgba(0, 0, 0, 0.6)",
        opacity: 0.7,
    },
    gettingbtn: {
        background: "rgba(0, 0, 0, 0.04)",
        paddingTop: 0,
        justifyContent: "flex-end",
    },
    gettingInBtn: {
        color: "purple",
        opacity: 0.7,
        padding: 0,
    },
    iconText: {
        color: "rgba(0, 0, 0, 0.5)",
        fontSize: theme.spacing(1.8),
    },
    btnDurationLight: {
        padding: "0 8px",
        float: "right",
        marginTop: theme.spacing(-4),
        marginRight: theme.spacing(1),
    },
    cardGuests: {
        position: "absolute",
        zIndex: 9,
    },
    dashboardTitle: {
        color: "rgba(0, 0, 0, 0.5)",
        fontStyle: "normal",
        fontWeight: 500,
        fontSize: theme.spacing(1.8),
    },
    dashboardSubTitle: {
        color: "#140524",
        fontStyle: "normal",
        fontWeight: 700,
        fontSize: theme.spacing(3),
    },
    dashboardSubDarkTitle: {
        color: "#140524",
        fontStyle: "normal",
        fontWeight: 700,
        fontSize: theme.spacing(1.8),
    },
    dashboardSubSemiTitle: {
        color: "#7900F8",
        fontStyle: "normal",
        fontWeight: 700,
        fontSize: theme.spacing(1.8),
    },
    dashboardSubNormalTitle: {
        color: "#000000",
        fontStyle: "normal",
        opacity: 0.7,
        fontWeight: 700,
        fontSize: theme.spacing(1.8),
    },
    dashboardAction: {
        color: theme.palette.secondary.main,
        fontSize: theme.spacing(1.8),
        fontWeight: 500,
    },
    bgwhite: {
        background: "white",
    },
    borderRadius: {
        borderRadius: theme.spacing(1),
    },
    endDiv: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "85%",
    },
    backButton: {
        marginRight: theme.spacing(1),
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    productBox: {
        width: theme.spacing(10),
        height: theme.spacing(10),
        border : "1px solid #DEDEDE",
        borderRadius : 8,
        marginRight : 8,
        background: "white",
        "&:img": {
            maxHeight: theme.spacing(12),
        },
    },
    sideList: {
        minHeight: "70vh",
        maxHeight: "70vh",
        overflowY: "scroll",
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        [theme.breakpoints.down("md")]: {
            minHeight: "58vh",
            maxHeight: "58vh",
        },
    },
    guestList: {
        height: "37vh",
        overflowY: "auto",
        overflowX: "hidden",
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    selectedTags: {
        display: "flex",
        background: "white",
        border: "1px solid #CECECE",
        padding: theme.spacing(1),
        borderRadius: theme.spacing(1),
        "& input": {
            padding: theme.spacing(0.5),
        },
        "& .tag-wrapper": {
            marginRight: theme.spacing(1),
            border: "1px solid #CECECE",
            padding: theme.spacing(0.5),
            borderRadius: theme.spacing(1),
            "& button": {
                border: "none",
                background: "transparent",
                marginLeft: theme.spacing(1),
            },
        },
    },
    bgAvatar: {
        background: "rgba(121, 0, 248, 0.05)",
        padding: theme.spacing(1),
        width: theme.spacing(8),
        height: theme.spacing(8),
        "& img": {
            width: theme.spacing(5),
            height: theme.spacing(5),
        },
    },
}));
